import { WorkflowRole } from '@exam-management/common/types';
import { WorkflowStepCode } from '@exam-management/graphql';
import type { QSetReviewWorkflowStepCode } from '@exam-management/task-management';

export enum QSetSubtaskStartSectionVariant {
  HIDDEN = 'HIDDEN',
  ACTIONABLE = 'ACTIONABLE',
}

const variant = {
  [WorkflowRole.TASK_OWNER]: {
    [WorkflowStepCode.ReviewQsetTodo]: QSetSubtaskStartSectionVariant.HIDDEN,
    [WorkflowStepCode.ReviewQsetInReview]: QSetSubtaskStartSectionVariant.HIDDEN,
    [WorkflowStepCode.ReviewQsetReviewed]: QSetSubtaskStartSectionVariant.HIDDEN,
    [WorkflowStepCode.ReviewQsetDone]: QSetSubtaskStartSectionVariant.HIDDEN,
  },
  [WorkflowRole.SUBTASK_ASSIGNER]: {
    [WorkflowStepCode.ReviewQsetTodo]: QSetSubtaskStartSectionVariant.HIDDEN,
    [WorkflowStepCode.ReviewQsetInReview]: QSetSubtaskStartSectionVariant.HIDDEN,
    [WorkflowStepCode.ReviewQsetReviewed]: QSetSubtaskStartSectionVariant.HIDDEN,
    [WorkflowStepCode.ReviewQsetDone]: QSetSubtaskStartSectionVariant.HIDDEN,
  },
  [WorkflowRole.SUBTASK_ASSIGNEE]: {
    [WorkflowStepCode.ReviewQsetTodo]: QSetSubtaskStartSectionVariant.ACTIONABLE,
    [WorkflowStepCode.ReviewQsetInReview]: QSetSubtaskStartSectionVariant.HIDDEN,
    [WorkflowStepCode.ReviewQsetReviewed]: QSetSubtaskStartSectionVariant.HIDDEN,
    [WorkflowStepCode.ReviewQsetDone]: QSetSubtaskStartSectionVariant.HIDDEN,
  },
};

export default function getQSetSubtaskStartSectionVariant(
  roles: { isOwner: boolean; isAssigner: boolean; isAssignee: boolean },
  workflowStepCode: QSetReviewWorkflowStepCode,
): keyof typeof QSetSubtaskStartSectionVariant | null {
  if (roles.isOwner) {
    return variant[WorkflowRole.TASK_OWNER][workflowStepCode];
  }

  if (roles.isAssigner && roles.isAssignee) {
    // REMARK: if users are assigner and assignee, they are always SUBTASK_ASSIGNEE
    return variant[WorkflowRole.SUBTASK_ASSIGNEE][workflowStepCode];
  }

  if (roles.isAssigner) {
    return variant[WorkflowRole.SUBTASK_ASSIGNER][workflowStepCode];
  }

  if (roles.isAssignee) {
    return variant[WorkflowRole.SUBTASK_ASSIGNEE][workflowStepCode];
  }

  return null;
}
